import { useRouter } from 'next/router'
import { type FC, memo, useMemo } from 'react'
import styled from 'styled-components'

import UnderlineTabs from 'components/Button/UnderlineTabs'
import ROUTES from 'constants/routes'
import media from 'styles/media'

export const PointsTabs = {
	OVERVIEW: 'overview',
	INVITES: 'invites',
	SEASONS: 'seasons',
	HISTORY: 'history',
} as const

export type PointsTab = (typeof PointsTabs)[keyof typeof PointsTabs]

export const RewardsTabValues = Object.values(PointsTabs)

type PointsTabsProps = {
	activeTab: PointsTab
}

const RewardsTabsMenu: FC<PointsTabsProps> = memo(({ activeTab }) => {
	const router = useRouter()

	const historyTabs = useMemo(
		() => [
			{
				name: PointsTabs.OVERVIEW,
				label: 'Overview',
				active: activeTab === PointsTabs.OVERVIEW,
				onClick: () => router.push(ROUTES.Dashboard.Points(PointsTabs.OVERVIEW)),
			},
			{
				name: PointsTabs.SEASONS,
				label: 'Seasons',
				active: activeTab === PointsTabs.SEASONS,
				onClick: () => router.push(ROUTES.Dashboard.Points(PointsTabs.SEASONS), undefined),
			},
			{
				name: PointsTabs.HISTORY,
				label: 'History',
				active: activeTab === PointsTabs.HISTORY,
				onClick: () => router.push(ROUTES.Dashboard.Points(PointsTabs.HISTORY), undefined),
			},
		],
		[activeTab, router]
	)
	return <StyledUnderlineTabs options={historyTabs} noBorders />
})

const StyledUnderlineTabs = styled(UnderlineTabs)`
	height: 45px;
	width: 100%;
	border-bottom: ${(props) => props.theme.colors.selectedTheme.newTheme.border.style};
	& > div:first-child {
		padding-left: 0;
	}

	${media.lessThan('lg')`
		overflow-x: auto;
		white-space: nowrap;
	`}
`

export default RewardsTabsMenu
